import { getEnvVariable } from './constants/brandConfig';

export type TawkSiteConfig = {
  brandDomain: string;
  propertyId: string;
  widgetId: string;
};

/**
 * Tawk widget ids live on the brand's WhitelabelEnvDTO (TAWK_PROPERTY_ID / TAWK_WIDGET_ID),
 * so any host that maps to that brand (including aliases) gets Tawk.
 */
export function getTawkSiteConfig(hostname: string): TawkSiteConfig | null {
  try {
    const propertyId = getEnvVariable(hostname, 'TAWK_PROPERTY_ID');
    const widgetId = getEnvVariable(hostname, 'TAWK_WIDGET_ID');
    if (!propertyId || !widgetId) return null;

    return {
      brandDomain: getEnvVariable(hostname, 'BRAND_DOMAIN'),
      propertyId,
      widgetId,
    };
  } catch {
    // Host with no white-label config.
    return null;
  }
}
